import * as React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"
import { useAdminBrandForm } from "../../@hooks"
import { formData } from "../../@signals"


export default function AdminBrandsCompanyAutocomplete({ disabled }) {
	const { value, handleChange } = useAdminBrandForm('companyID')

	return <AutocompleteAjaxSeeker
		urlAjax={`${BACKEND_APIS.BRANDS}/crud/company`}
		label="Company"
		placeholder="Select Company..."
		value={value}
		disabled={disabled}
		onChange={(e, op) => {
			handleChange(e.target.value)
			formData.value.companyName = op?.label
		}}
	/>
}